import React from "react";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 * @description
 * Re-usable table component for CMED
 */

// example prop data
//   const data: DataItem[] = [
//     { bid: 12, bidq: 1, offer: 1, offerq: 1 },
//     { bid: 12, bidq: 1, offer: 1, offerq: 1 },
//     { bid: 12, bidq: 1, offer: 1, offerq: 1 },
//   ];
//   const headings: Heading[] = [
//     { heading: "BID QTY", align: "start", id: 1 },
//     { heading: "BID PRICE", align: "end", id: 2 },
//     { heading: "OFFER PRICE", align: "start", id: 3 },
//     { heading: "OFFER QTY", align: "end", id: 4 },
//   ];

interface Heading {
  heading: string;
  align: string;
  id: number;
}
interface DataItem {
  [key: string]: string | number;
}

const RenderTable: React.FC<{
  tableHeadings: Heading[];
  tableData: DataItem[];
  colsRight?: string[];
}> = ({ tableHeadings, tableData, colsRight }) => {
  return (
    <div>
      <div className="table_header_container">
        {tableHeadings.map((elem: Heading, id: number) => {
          return (
            <div className="table_header_item" key={id}>
              <p className={elem.align}>{elem.heading}</p>
            </div>
          );
        })}
      </div>
      {tableData.map((elem, id: number) => (
        <div className="table_data_container" key={id}>
          {Object.entries(elem).map(([key, value]) => (
            <div className="table_data_item" key={key}>
              <p
                className={
                  colsRight?.includes(key) ? "alignRight" : "alignLeft"
                }
              >
                {value}
              </p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default RenderTable;
